import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/motion-optimization.css';

import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';

Amplify.configure(awsconfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
